import { WIX_CODE } from '@wix/app-definition-ids'
import type {
  EditorSDK,
  WixCodeAppApi,
  WixCodeAuthParams,
} from '@wix/wix-data-client-common-standalone'

export const getWixCodeAuthParams = async ({
  editorSdkProxy,
}: {
  editorSdkProxy: EditorSDK
}): Promise<WixCodeAuthParams | undefined> => {
  const wixCodeInstalled =
    await editorSdkProxy.document.application.isApplicationInstalled({
      appDefinitionId: WIX_CODE,
    })

  if (!wixCodeInstalled) {
    return undefined
  }

  const wixCodePublicApi =
    await editorSdkProxy.document.application.getPublicAPI<WixCodeAppApi>({
      appDefinitionId: WIX_CODE,
    })

  if (!wixCodePublicApi) {
    throw new Error(
      'Wix Code is installed, but Wix Code public API is not available',
    )
  }

  return wixCodePublicApi.getWixCodeAuthParams()
}
